<template>
  <notification-box v-if="!isCompleted">
    <div slot="info">
      <a-progress
        type="circle"
        :percent="percent"
        :width="28"
        :showInfo="false"
        :strokeWidth="16"
        strokeColor="#f3c959"
      />
      <span class="text">
        <span class="percent">{{ percent }}%</span>
        {{ $t('completion.filled') }}. {{ $t('completion.description') }}.
      </span>
    </div>
    <slot name="actions" v-if="showClose" class="close" @click="close">×</slot>
  </notification-box>
</template>

<script>
import { mapMutations } from 'vuex';
import { CLOSE_DATA_FILLING_HINT } from '@/store/targetingInfo/mutationTypes';
import NotificationBox from '@/components/account/NotificationBox.vue';

export default {
  props: {
    showClose: Boolean,
    percent: Number,
  },
  components: {
    NotificationBox,
  },
  computed: {
    isCompleted() {
      return this.percent === 100;
    },
  },
  methods: {
    ...mapMutations({
      close: CLOSE_DATA_FILLING_HINT,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
@import '~@/assets/styles/variables.scss';

.text {
  margin: 8px;
}
.percent {
  font-weight: bold;
}
.close {
  color: $text-d-grey;
  font-size: 24px;
  cursor: pointer;
}
</style>
